import createAction, { createOptimisticAction } from 'Store/utils/createAction';
import type { PriceOfStayCriteria } from 'Store/price-remote/price-of-stay/priceOfStay.helper';
import {
  fetchPriceOfStay,
  getPriceOfStayArgs,
} from 'Store/price-remote/price-of-stay/priceOfStay.helper';
import {
  PRICE_OF_STAY_REQUEST,
  PRICE_OF_STAY_REQUEST_ABORT,
  RESET_PRICE_OF_STAY,
} from 'Store/price-remote/constants';
export const getPriceOfStay = (appContext: AppContext, searchCriteria: PriceOfStayCriteria) => {
  const args = getPriceOfStayArgs(searchCriteria);
  return (dispatch: ReduxDispatch, getState: GetReduxState) => {
    const state = getState();

    if (
      JSON.stringify(args) === JSON.stringify(state.priceRemote?.priceOfStay?.priceOfStayArgs ?? {})
    ) {
      return dispatch(createAction(PRICE_OF_STAY_REQUEST_ABORT, {}));
    }

    return dispatch(
      createOptimisticAction(
        PRICE_OF_STAY_REQUEST,
        {
          args,
        },
        {
          optimist: true,
          promise: fetchPriceOfStay(appContext, searchCriteria),
        },
      ),
    );
  };
};
export const resetPriceOfStay = () => createAction(RESET_PRICE_OF_STAY);
